import { useCallback, useState } from "react";

/**
|--------------------------------------------------
| 文字列型パラメータの初期化
| 
| ★使用例
|   const [input, updateInput, resetInput] = useInitText();
|--------------------------------------------------
*/
export function useInitText(initialValue?: string): [string, (value: string) => void, () => void] {
    const [value, setValue] = useState<string>(initialValue || "");

    const handleInputChange = useCallback((target) => setValue(target), []);

    const reset = useCallback(() => setValue(""), []);

    return [value, handleInputChange, reset];
}
